/**
 * The build-time configuration this bundle carries.
 *
 * Two values, both with a working default, because the default is the deployment we want: the
 * app and the API behind one origin, so the session cookie is same-origin and `sameSite=lax`
 * never withholds it. `VITE_API_BASE_URL` exists for the deployments where that is not possible
 * and the API answers on an origin of its own.
 *
 * Read through brackets rather than `import.meta.env.VITE_…`: `ImportMetaEnv` is an index
 * signature, and `noPropertyAccessFromIndexSignature` is on precisely so a typo in a variable
 * name is an error here instead of an `undefined` at runtime.
 */

function readString(value: unknown, fallback: string): string {
  return typeof value === 'string' && value.length > 0 ? value : fallback;
}

/**
 * Same-origin by default. A trailing slash is stripped so callers can always concatenate.
 */
const apiBaseUrl = readString(import.meta.env['VITE_API_BASE_URL'], '').replace(/\/+$/u, '');

/**
 * Must match `SESSION_COOKIE_NAME` + `_csrf` on the API (see `apps/api/src/plugins/auth.ts`).
 *
 * The CSRF cookie is the one cookie in the pair that is deliberately *not* `httpOnly`, because
 * the double-submit pattern needs the client to read it and echo it in a header. If this name is
 * wrong, every mutation fails with a 403 and nothing else looks broken.
 */
const csrfCookieName = readString(import.meta.env['VITE_CSRF_COOKIE_NAME'], 'catalog_session_csrf');

export const webEnv = {
  apiBaseUrl,
  csrfCookieName,
  /** `/api/v1`, per `API_PREFIX` in `apps/api/src/plugins/docs.ts`. */
  apiPrefix: `${apiBaseUrl}/api/v1`,
} as const;
